import { DayStats } from './day-stats';
import { StatisticDay } from '../../app/statistics/supa-statistics.component';
import dayjs from 'dayjs';
import { dateFormat } from '../../tools/date';
import { JournalDayStatsViewModel } from './journal-day-stats-view-model';

export const createJournalDayStatsViewModel = (
  startDate: string,
  endDate: string,
  dayStats: DayStats,
  mode: 'week' | 'month' = 'week'
): JournalDayStatsViewModel => {

  const data: Array<Array<StatisticDay>> = [];
  let rowLabels: string[] = ['Mo', '', 'Mi', '', 'Fr', '', 'So'];

  if (mode === 'month') {
    rowLabels = [];
    for (let d = 1; d <= 31; d++) {
      rowLabels.push(d % 5 === 0 ? String(d) : '');
    }
  }


  const columnLabels: string[] = [];
  let maxCharsOfDay = 0;

  let columnCursor = 0;
  let cursor = dayjs(startDate);


  let columnLabelControlArray: string[] = [];


  if (dayStats) {

    while (!cursor.isSame(endDate)) {
      if (!data[columnCursor]) {
        data[columnCursor] = [];
      }
      const currentDate = cursor.format(dateFormat);
      const statsOfDay = dayStats
        .find(x => x.day === currentDate);
      const totalCharsOfDay = statsOfDay?.total_content_chars || 0;

      data[columnCursor].push({
        date: currentDate,
        charCount: totalCharsOfDay
      });

      if (totalCharsOfDay > maxCharsOfDay) {
        maxCharsOfDay = totalCharsOfDay;
      }

      // reset months on 01.01.
      if (cursor.month() === 0 && cursor.date() === 1) {
        columnLabelControlArray = []
      }

      if (cursor.isSame(cursor.startOf(mode), 'day')) {
        let month = cursor.format('MMM');

        // if (mode === 'month') {
        //   month = month[0];
        //   columnLabels.push(month);
        // } else if (mode === 'week') {
        //   if (columnLabelControlArray.includes(month)) {
        //     columnLabels.push('');
        //   } else {
        //     columnLabels.push(month);
        //     columnLabelControlArray.push(month);
        //   }
        // }

        if (columnLabelControlArray.includes(month)) {
          columnLabels.push('');
        } else {
          columnLabels.push(month);
          columnLabelControlArray.push(month);
        }
      }

      // if (cursor.day() === 6) {
      if (cursor.isSame(cursor.endOf(mode), 'day')) {
        columnCursor++;
      }


      cursor = cursor.add(1, 'day');
    }
    if (mode === 'week') {
      columnLabels[0] = '';
    }
  }

  return {data, rowLabels, columnLabels, maxCharsOfDay}

}
